import PropTypes from 'prop-types';
import { Button, Card, Col, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap';

import '../../../common/search/styles.css';

const QrCodeCampaignsSearch = ({
  filters,
  onChange,
  onSearch,
  onClear
}) => {
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <Card className="simple-filter admin-search-filter">
      <Card.Body>
        <Row>
          <Col md={4}>
            <FormGroup>
              <FormLabel>
                Campaign unique ID
              </FormLabel>
              <FormControl
                onChange={onChange('campaign_unique_id')}
                onKeyPress={handleKeyPress}
                placeholder="Campaign unique ID"
                value={filters.campaign_unique_id}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <FormLabel>
                Start date from
              </FormLabel>
              <FormControl
                onChange={onChange('start_date_from')}
                type="date"
                value={filters.start_date_from}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <FormLabel>
                End date to
              </FormLabel>
              <FormControl
                onChange={onChange('end_date_to')}
                type="date"
                value={filters.end_date_to}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Button
              className="red-ghost-btn"
              onClick={onSearch}
            >
              Search
            </Button>
            <Button
              className="red-ghost-btn"
              onClick={onClear}
              style={{ marginLeft: '10px' }}
            >
              Clear filters
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

QrCodeCampaignsSearch.propTypes = {
  filters: PropTypes.shape({
    campaign_unique_id: PropTypes.string,
    start_date_from: PropTypes.string,
    end_date_to: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired
};

export default QrCodeCampaignsSearch;
